import React, { useState } from "react";
import styles from "./index.module.scss";
import { Button, Form, Input, Modal, Radio, message } from "antd";
import { post } from "../../../services/request";
import { ADD_USER } from "../../../services/request/urls";

export interface AddUserButtonProps {}

const AddUserButton: React.FC<AddUserButtonProps> = (props) => {
  const [dialogVisible, setDialogVisible] = useState(false);
  const [form] = Form.useForm();

  const onSubmit = () => {
    form.validateFields().then((values) => {
      const data = { ...values };
      delete data.passwordRepeat;

      post(ADD_USER, data, true)
        .then((res) => {
          if (res?.code === 1) {
            message.success("新建用户成功");
          } else {
            message.error(res?.message || "新建用户失败");
          }
        })
        .catch(() => {
          message.error("新建用户失败");
        })
        .finally(() => {
          setDialogVisible(false);
        });
    });
  };

  const onCancel = () => {
    setDialogVisible(false);
  };

  return (
    <>
      <Button type="primary" onClick={() => setDialogVisible(true)}>
        添加用户
      </Button>

      <Modal
        title="添加用户"
        visible={dialogVisible}
        onOk={onSubmit}
        onCancel={onCancel}
        cancelText="取消"
        okText="提交"
      >
        <Form labelCol={{ span: 4 }} wrapperCol={{ span: 20 }} form={form}>
          <Form.Item label="账号" name="account" rules={[{ required: true, message: "账号不能为空" }]}>
            <Input />
          </Form.Item>
          <Form.Item label="用户名" name="name" rules={[{ required: true, message: "用户名不能为空" }]}>
            <Input />
          </Form.Item>
          <Form.Item label="手机号" name="phone" rules={[{ required: true, message: "手机号不能为空" }]}>
            <Input />
          </Form.Item>
          <Form.Item
            label="密码"
            name="password"
            rules={[
              { required: true, message: "密码不能为空" },
              {
                pattern: new RegExp("(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[^a-zA-Z0-9]).{8,30}"),
                message: "请输入8至30位包含大小写英文字母、数字、特殊字符的密码",
              },
            ]}
          >
            <Input type="password" />
          </Form.Item>
          <Form.Item
            label="重复密码"
            name="passwordRepeat"
            rules={[
              { required: true, message: "密码不能为空" },
              ({ getFieldValue }) => ({
                validator(rule, value) {
                  if (!value || getFieldValue("password") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject("两次密码输入不一致");
                },
              }),
            ]}
          >
            <Input type="password" />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default AddUserButton;
